import useSWR from "swr"
import {API_ECP_PROJECTS} from "../constants/apiUrls"

export default function useEcpConfig(projectId) {
    const {data, mutate, error} = useSWR(`${API_ECP_PROJECTS}/${projectId}/config`)
    return {
        ecpConfig: data,
        mutateEcpConfig: mutate,
        isLoadingEcpConfig: !error && !data,
        isErrorEcpConfig: error
    }
}